export const ICON_FR_KEYWORDS: Record<string, string[]> = {
    'icon-activities': ['activités', 'loisirs'],
    'icon-alert': ['alerte', 'avertissement'],
    'icon-alert-circle': ['alerte', 'cercle'],
    'icon-alert-octagon': ['alerte', 'octogone', 'danger'],
    'icon-ambulance-5': ['ambulance', 'urgence', 'santé'],
    'icon-analytics-graph-bar': ['graphique', 'statistiques', 'données'],
    'icon-assembly': ['assemblée', 'réunion'],
    'icon-audio-file-volume': ['audio', 'son', 'fichier'],
    'icon-baby-trolley': ['bébé', 'poussette', 'famille'],
    'icon-baggage': ['bagage', 'valise', 'voyage'],
    'icon-beach-6': ['plage', 'sable', 'mer'],
    'icon-beach-parasol-water-1': ['plage', 'parasol', 'eau'],
    'icon-biblio': ['bibliothèque', 'livres'],
    'icon-biking-person': ['vélo', 'cycliste', 'piste cyclable'],
    'icon-binocular': ['jumelles', 'observation'],
    'icon-building-2': ['bâtiment', 'immeuble'],
    'icon-building-modern-1': ['bâtiment', 'immeuble', 'moderne'],
    'icon-calendar': ['calendrier', 'date'],
    'icon-calendar-add': ['calendrier', 'ajouter', 'date'],
    'icon-camera': ['caméra', 'photo'],
    'icon-camping-tent-3': ['camping', 'tente', 'plein air'],
    'icon-car': ['voiture', 'auto', 'véhicule'],
    'icon-chatbot': ['chatbot', 'robot', 'assistant'],
    'icon-check': ['coche', 'validation', 'confirmer'],
    'icon-check-circle': ['validation', 'confirmer', 'cercle'],
    'icon-city': ['ville', 'cité'],
    'icon-clock': ['horloge', 'temps', 'heure'],
    'icon-cog': ['paramètres', 'engrenage', 'configuration'],
    'icon-compass': ['boussole', 'direction'],
    'icon-compost-bin': ['compost', 'déchets', 'organique'],
    'icon-construction': ['construction', 'travaux', 'chantier'],
    'icon-consultation': ['consultation', 'avis', 'citoyen'],
    'icon-edit': ['modifier', 'éditer', 'crayon'],
    'icon-email': ['courriel', 'messagerie'],
    'icon-envelope': ['enveloppe', 'courrier'],
    'icon-family': ['famille'],
    'icon-flag': ['drapeau', 'signalement'],
    'icon-folder': ['dossier'],
    'icon-graffiti': ['graffiti', 'vandalisme'],
    'icon-hammer-1': ['marteau', 'réparation', 'travaux'],
    'icon-home': ['maison', 'résidence', 'domicile'],
    'icon-home-filled': ['maison', 'résidence'],
    'icon-ice-rink': ['patinoire', 'glace', 'hiver'],
    'icon-info': ['information', 'aide'],
    'icon-key-lock': ['clé', 'serrure', 'sécurité'],
    'icon-landmark-japan-shrine': ['monument', 'patrimoine'],
    'icon-like-1': ['aimer', 'approuver', 'pouce'],
    'icon-link': ['lien', 'url'],
    'icon-list': ['liste'],
    'icon-logout': ['déconnexion', 'quitter'],
    'icon-map': ['carte', 'plan'],
    'icon-map-active': ['carte', 'plan', 'actif'],
    'icon-maps-pin': ['épingle', 'localisation', 'carte'],
    'icon-megaphone-1': ['mégaphone', 'annonce', 'communication'],
    'icon-menu': ['menu', 'navigation'],
    'icon-mobile-phone-2': ['téléphone', 'mobile', 'cellulaire'],
    'icon-money-wallet-open': ['portefeuille', 'argent', 'paiement'],
    'icon-mood-happy': ['sourire', 'satisfaction'],
    'icon-no-parking': ['stationnement', 'interdit', 'défense'],
    'icon-notifications': ['notifications', 'alertes'],
    'icon-office-file-pdf': ['pdf', 'document', 'fichier'],
    'icon-outdoors-tree-valley': ['nature', 'arbre', 'vallée', 'plein air'],
    'icon-parking': ['stationnement', 'parking'],
    'icon-parking-meter': ['parcomètre', 'stationnement', 'horodateur'],
    'icon-parking-zone': ['zone', 'stationnement'],
    'icon-pencil-2': ['crayon', 'écriture'],
    'icon-phone-alerts': ['téléphone', 'alerte'],
    'icon-pin': ['épingle', 'localisation'],
    'icon-pool': ['piscine', 'natation', 'eau'],
    'icon-pot-hole': ['nid de poule', 'route', 'asphalte', 'chaussée'],
    'icon-privacy': ['confidentialité', 'vie privée'],
    'icon-qr-code': ['qr code', 'code-barres'],
    'icon-question': ['question', 'aide', 'faq'],
    'icon-receipt': ['reçu', 'facture', 'paiement'],
    'icon-recycling': ['recyclage', 'déchets'],
    'icon-recycling-bin': ['bac', 'recyclage', 'déchets'],
    'icon-refresh': ['actualiser', 'recharger'],
    'icon-requests': ['requêtes', 'demandes'],
    'icon-restaurant': ['restaurant', 'nourriture', 'repas'],
    'icon-sail-ship-7': ['voilier', 'bateau', 'nautique'],
    'icon-schedule-meeting': ['réunion', 'rendez-vous', 'calendrier'],
    'icon-school-bus-side-1': ['autobus scolaire', 'école', 'transport'],
    'icon-search': ['recherche'],
    'icon-services-status': ['état', 'services', 'statut'],
    'icon-setting': ['paramètres', 'configuration'],
    'icon-shield-2-2': ['bouclier', 'sécurité', 'protection'],
    'icon-skiing-cross-country': ['ski', 'hiver', 'sport'],
    'icon-slippery-ice': ['glissant', 'glace', 'verglas', 'hiver'],
    'icon-snow': ['neige', 'hiver', 'météo'],
    'icon-snowblower': ['souffleuse', 'déneigement', 'neige', 'hiver'],
    'icon-star': ['étoile', 'favori'],
    'icon-star-filled': ['étoile', 'favori'],
    'icon-street-lamp': ['lampadaire', 'éclairage', 'rue', 'lampe'],
    'icon-swimming': ['natation', 'nager', 'piscine'],
    'icon-tag': ['étiquette', 'tag'],
    'icon-tennis': ['tennis', 'sport'],
    'icon-theatre': ['théâtre', 'culture', 'spectacle'],
    'icon-timer': ['minuterie', 'temps', 'chronomètre'],
    'icon-town-hall': ['hôtel de ville', 'mairie', 'municipalité'],
    'icon-trash-bin': ['poubelle', 'déchets', 'ordures'],
    'icon-trash-bin-2': ['poubelle', 'déchets', 'ordures'],
    'icon-tree': ['arbre', 'nature', 'forêt'],
    'icon-trusted': ['confiance', 'vérifié'],
    'icon-user-add': ['utilisateur', 'ajouter'],
    'icon-user-profile': ['utilisateur', 'profil'],
    'icon-warning': ['avertissement', 'attention', 'danger'],
    'icon-water-in-service': ['eau', 'service', 'aqueduc'],
    'icon-water-service-interruption': ['eau', 'interruption', 'aqueduc', 'bris'],
    'icon-wench-double': ['clé anglaise', 'réparation', 'maintenance'],
};
